export default __webpack_public_path__ + "static/media/title_pc.82251461.png";